import React from "react";
import BlogFortySeven from "../component/BlogFortySeven";

function BlogFortySevenContainer() {
  return <BlogFortySeven />;
}

export default BlogFortySevenContainer;
